export default {
  state: {
    spotInForm: null,
  },
  getters: {
    spotInForm: state => state.spotInForm,
  },
  mutations: {
    SET_SPOT_IN_FORM(state, obj) {
      state.spotInForm = obj
    },
    UPDATE_SPOT_IN_FORM(state, obj) {
      state.spotInForm = {...(state.spotInForm || {}), ...obj}
    }
  },
  actions: {
    async logoutActions({ commit }) {
      commit('SET_SPOT_IN_FORM', null)
    }
  }
}